import { useState, useEffect } from 'react';
import { getTranslations } from '../utils/i18n';

/**
 * 自定义Hook：使用多语言翻译
 * 自动监听语言变化并更新翻译
 */
export const useTranslation = () => {
  const [translations, setTranslations] = useState(getTranslations());

  useEffect(() => {
    // 监听语言变化事件
    const handleLanguageChange = () => {
      setTranslations(getTranslations());
    };

    window.addEventListener('languageChange', handleLanguageChange);

    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  return translations;
};

export default useTranslation;

